import InstalledInfoSearch from './InstalledInfoSearch'

export default InstalledInfoSearch;